import React, { Component } from "react";
import "./LowAmountCheckBox.css";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";

let langData = require("../../../Data/language.json");

const ColoredCheckbox = withStyles({
  root: {
    color: "white",
    "&$checked": {
      color: "white",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default class LowAmountCheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.amount,
      checkState: false,
    };
  }

  componentDidMount = () => {
    if (this.state.value <= 20) {
      this.setState({ checkState: true });
    }
  };

  onCheckClick = () => {
    if (this.state.checkState === false) {
      this.setState({ value: 20 }, () =>
        this.props.onEditItemSlider(this.state.value)
      );
    } else {
      this.setState({ value: 100 }, () =>
        this.props.onEditItemSlider(this.state.value)
      );
    }
    this.setState({ checkState: !this.state.checkState });
  };

  render() {
    return (
      <div className="row checkBoxDiv">
        <ColoredCheckbox
          className="lowAmountButton"
          checked={this.state.checkState}
          onChange={() => this.onCheckClick()}
          value="checkedG"
        />

        <p onClick={() => this.onCheckClick()} className="lowAmountText">
          {langData[this.props.language].listItem.lowAmount}
        </p>
      </div>
    );
  }
}
